import { ResolverHttpClient } from '../resolvers/definition/httpClient';
import { isHubteamDomain } from '../utils/isHubteamDomain';

let _defaultClient: ResolverHttpClient | undefined;

export const setDefaultHttpClient = (
  client: ResolverHttpClient | undefined
) => {
  _defaultClient = client;
};

const TOOLS_REGEX = /^(?:.*)tools(?:-[^.]+)?\.hubteam/;
const HUBTEAM_DOMAIN = /\.hubteam(qa)?\.com$/;

export function configureChirpFetch(
  hostname = (typeof window !== 'undefined' && window.location?.hostname) || ''
) {
  const { createChirpFetch, loadBalancers, chirpGateways } =
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('chirp-fetch') as typeof import('chirp-fetch');

  if (TOOLS_REGEX.test(hostname)) {
    setDefaultHttpClient(
      createChirpFetch({
        loadBalancer: loadBalancers.TOOLS,
        gateway: chirpGateways.INTERNAL,
      }) as ResolverHttpClient
    );
  } else if (HUBTEAM_DOMAIN.test(hostname)) {
    setDefaultHttpClient(
      createChirpFetch({
        loadBalancer: loadBalancers.PRIVATEHUBTEAM,
        gateway: chirpGateways.INTERNAL,
      }) as ResolverHttpClient
    );
  } else {
    setDefaultHttpClient(
      createChirpFetch({
        loadBalancer: loadBalancers.APP,
        gateway: chirpGateways.APP,
      }) as ResolverHttpClient
    );
  }
}

export const getDefaultHttpClient = (): ResolverHttpClient => {
  if (_defaultClient) {
    return _defaultClient;
  }

  if (isHubteamDomain()) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _defaultClient = require('hub-http-janus/clients/adaptiveIdpAuthApiClient')
      .default as typeof import('hub-http-janus/clients/adaptiveIdpAuthApiClient').default;
  } else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _defaultClient = require('hub-http/clients/apiClient')
      .default as typeof import('hub-http/clients/apiClient').default;
  }

  return _defaultClient;
};

export const __testOnly_resetDefaultHttpClient = () => {
  _defaultClient = undefined;
};
